const initialState = {
  siteList: null,
  loading: true
}

export default initialState
